module.exports = __webpack_public_path__ + "images/icon_sound_on_b3f9c03b7e56350f2076932c3ca1194c.svg";